var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["SCROLL_BOX"] = "scroll-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_BORDER_BOX"] = "device-pixel-border-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));
export { ResizeObserverBoxOptions };
